export const ElectronicsLandingPagePopulateParams = [
  'seo.og_image',
  'why_section.cards.image',
  'how_section.cards.image',
  'introduction_section.image',
  'introduction_section.image_2x',
  'introduction_section.image_mobile',
  'introduction_section.image_mobile_2x',
  'discover_section.cards.image',
  'bottom_section',
  'disclaimer_section',
]

export enum ElectronicsLandingPageEvent {
  BuyLandingPageView = 'user.view_landingpage_electronics_buyer',
  SellLandingPageView = 'user.view_landingpage_electronics_seller',
  BuyIntroLinkClick = 'user.landingpage_electronics_buyer_shop_electronics',
  SellIntroLinkClick = 'user.landingpage_electronics_seller_shop_electronics',
  BuyWhyLinkClick = 'user.landingpage_electronics_buyer_why_click_card_link',
  SellWhyLinkClick = 'user.landingpage_electronics_seller_why_click_card_link',
  BuyDiscoverAllLinkClick = 'user.landingpage_electronics_buyer_discover_click_all_link',
  SellDiscoverAllLinkClick = 'user.landingpage_electronics_seller_discover_click_all_link',
  BuyDiscoverSubcategoryLinkClick = 'user.landingpage_electronics_buyer_discover_click_subcategory_link',
  SellDiscoverSubcategoryLinkClick = 'user.landingpage_electronics_seller_discover_click_subcategory_link',
  BuyBottomCtaClick = 'user.landingpage_electronics_buyer_bottom_click_cta',
  SellBottomCtaClick = 'user.landingpage_electronics_seller_bottom_click_cta',
  BuyBottomLinkClick = 'user.landingpage_electronics_buyer_bottom_click_link',
  SellBottomLinkClick = 'user.landingpage_electronics_seller_bottom_click_link',
}

export const ElectronicsBottomCtaClickEvents = {
  sell: ElectronicsLandingPageEvent.BuyBottomCtaClick,
  buy: ElectronicsLandingPageEvent.SellBottomCtaClick,
}

export const ElectronicsBottomLinkClickEvents = {
  sell: ElectronicsLandingPageEvent.BuyBottomLinkClick,
  buy: ElectronicsLandingPageEvent.SellBottomLinkClick,
}
